<!-- CLA le 12/02/2019 - T8323 - affichage des prix brut/net -->
<!-- CLA le 26/02/2019 - En attente test (remettre activePriceListType par la suite dans *ngIf) -->
<div *ngIf="false" class="dropdown header-element">
    <button class="btn btn-link dropdown-toggle header-icon">
      <i class="fa fa-file-invoice-dollar"></i>
      <span class="caption">{{ 'product.price' | translate }} {{ 'product.prices.'+activePriceListType+'Short' | translate }}</span>
    </button>
    <ul class="menu">
      <!--activePriceListType==PriceListType.Gross-->
      <li class="menu-item" (mousedown)="priceListTypeEmitted(priceListType.Gross)">
        <a>{{ 'product.prices.grossShort' | translate }}</a>
      </li>
      <li class="menu-item" (mousedown)="priceListTypeEmitted(priceListType.Net)">
        <a>{{ 'product.prices.netShort' | translate }}</a>
      </li>
    </ul>
  </div>